import './App.css';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
// import Experience from './components/Experience';
import Clinic from './components/Clinic';
import Services from './components/Services';
import Skills from './components/Skills';
import Facilities from './components/Facilities';
import Contact from './components/Contact';
import Footer from './components/Footer';
import {BrowserRouter,Route} from 'react-router-dom'

function App() {
  return (
    <BrowserRouter>
    <Navbar/>
    <Route exact path="/" >
      <Home />
    </Route>
    <Route path="/home" >
      <Home />
    </Route>
    <Route path="/about">
      <About />
    </Route>
    {/* <Route path="/experience">
      <Experience />
    </Route>*/}
    <Route path="/clinic">
      <Clinic />
    </Route> 
    <Route path="/services">
      <Services />
    </Route>
    <Route path="/skills">
      <Skills />
    </Route>
    <Route path="/facilities">
      <Facilities />
    </Route>
    <Route path="/contact">
      <Contact />
    </Route>
    <Footer/>
  </BrowserRouter>
  );
}

export default App;
